import React, { memo } from "react";
import { Col, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { InsuranceEntity } from "../entity";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import { ErrorMessage } from "@hookform/error-message";
import { ErrorField } from "../styles";

const messages = defineMessages({
  ticker: { id: "insurance.form.ticker", defaultMessage: "Ticker" },
  required: { id: "insurance.form.ticker.required", defaultMessage: "Ticker is required" },
});

export const TickerComponent = memo(
  (props: UseFormReturn<InsuranceEntity> & { readOnly?: boolean }) => {
    const intl = useIntl();

    return (
      <FormGroup as={Col}>
        <FormLabel column sm={12}>
          <FormattedMessage {...messages.ticker} /> {"*"}
        </FormLabel>
        <Col sm={3}>
          <FormControl
            readOnly={props.readOnly}
            maxLength={10}
            {...props.register("ticker", { required: intl.formatMessage(messages.required) })}
          />
          <ErrorMessage
            errors={props.formState.errors}
            name="ticker"
            render={({ message }) => <ErrorField>{message}</ErrorField>}
          />
        </Col>
      </FormGroup>
    );
  }
);
